import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    BackPayGroupDto, BackPayGroupPaginator,
    CreateBackPayGroupDto,
    QueryBackPayGroupDto,
    SearchBackPayGroupDto,
    UpdateBackPayGroupDto
} from "../models/back-pay-group.dto";
import ENDPOINTS from "./utils/endpoints";
import {QueryOptionsDto} from "../models/generic.dto";

export function useGetBackPayGroup(companyId: number, options?: QueryBackPayGroupDto) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BACKPAYGROUP.GET;
    const request = (options: QueryBackPayGroupDto) => API.ProcessingCompanyAPI.getBackPayGroups(companyId,options);

    const { data, isLoading, error, refetch } = useQuery<BackPayGroupPaginator, Error>(
        [url, options],
        ({ queryKey, pageParam }) => request(Object.assign({}, queryKey[1], pageParam)),
        {...API.Handlers.pageParamOption}
    );

    return { data, isLoading, error, refetch }
}

export function useGetBackPayGroupSearch() {

    return useMutation(
        (companyId: number, options?: SearchBackPayGroupDto) => API.ProcessingCompanyAPI.getBackPayGroupSearch(companyId, options),
        {
            onSuccess: () => {
                //toast.success('Record created successfully');
            },
            onError: API.Handlers.onErrorHandler,
        },
    );
}

export function useGetBackPayGroupById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.BACKPAYGROUP.DETAIL;
    const request = API.ProcessingCompanyAPI.getBackPayGroupById(companyId,id);

    const {data, isLoading, error} = useQuery<{ data:BackPayGroupDto }, Error>(
        [url, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateBackPayGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateBackPayGroupDto}) => API.ProcessingCompanyAPI.createBackPayGroup(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BACKPAYGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateBackPayGroup() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateBackPayGroupDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateBackPayGroup(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.BACKPAYGROUP.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteBackPayGroup() {

    return useMutation(
        ({companyId, id}: {companyId: number, id: number}) => API.ProcessingCompanyAPI.deleteBackPayGroupById(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}